/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

/**
 * Base styles for the mobile main nav component
 */
const baseStyles = css`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .categories-list {
        position: relative;
        top: 0;
        overflow: auto;
        h4 {
            margin-bottom: 2.8rem;
        }
    }

    .pre-footer-account {
        display: flex;
        align-items: center;
        padding-bottom: var(--layout-spacing-16);
    }

    .pre-footer-account-text {
        margin-left: 0.6rem;
        ${theme.typography.body_normal_highlight}
    }

    .pre-footer {
        padding: var(--layout-spacing-16) var(--layout-spacing-24);
        border-top: 0.1rem solid #e4e4ef;
    }

    .footer {
        width: 100%;

        .social-channels {
            border-top: 0.1rem solid #e4e4ef;
            padding: 1.4rem 0;
        }

        button.sell-trade-button {
            display: block;
            min-width: 22.5rem;
            text-align: center;
            margin: 0 auto var(--layout-spacing-24) auto;
        }
    }
`;

/**
 * The mobile main nav component styles
 */
export const styles = css`
    ${baseStyles}
`;
